<template>
  <div class="constructeur needResize" :class="{'fullscreen': fullscreen}" v-if="result">
    <Info @fullscreen="onFullScreen" title="constructeur.title" text="constructeur.info" ></Info>
    <div class="constructeur-title">
      <h3>{{$t('constructeur.title')}}</h3>
      <h2>{{$t('constructeur.description')}}</h2>
    </div>
    <div class="table-container">
      <div class="table">
        <div class="row header">
          <div class="cell header">
            {{$t('rank')}}
          </div>
          <div class="cell header">
            {{$t('brands')}}
          </div>
          <div class="cell header">
            {{$t('tickets')}}
          </div>
          <div class="cell header">
            {{$t('percentage')}}
          </div>
        </div>
        <div class="row" v-for="(constructor, index) in this.getItems">
          <div class="cell rang" data-title="RANG">
            {{index + 1}}
          </div>
          <div class="cell" data-title="MARQUES">
            {{constructor.key}}
          </div>
          <div class="cell" data-title="ARTICLES">
            {{constructor.doc_count | splitNumber}}
          </div>
          <div class="cell" data-title="POURCENTAGES">
            {{constructor.percentage}}%
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import Info from './Info.vue'
  export default {
    name: 'Constructeur',
    components: {
      Info
    },
    props: {
      result: Object
    },
    data() {
      return {
        fullscreen: false,
      }
    },
    mounted() {
    },
    computed: {
      getItems: function () {
        if (this.result && this.result.aggregations && this.result.aggregations['to-bills'] && this.result.aggregations['to-bills'].bills && this.result.aggregations['to-bills'].bills.vehicles && this.result.aggregations['to-bills'].bills.vehicles.brand_model)
          return this.result.aggregations['to-bills'].bills.vehicles.brand_model.buckets.slice(0, 10)
        else
          return []
      }
    },
    methods: {
      onFullScreen() {
        this.fullscreen = !this.fullscreen
      }
    }
  }
</script>

<style lang="scss" scoped>
  @import "@/assets/styles/components/constructeur.sass"
</style>
